module.exports = __webpack_public_path__ + "img/20201102-3.7cd1855d.jpg";